<form class="proto-input-form" novalidate
  [formGroup]="editForm"
  [ngClass]="{ 'is-disabled': isLoading }">

  @for (list of formFieldLists; track list.id) {

    <!-- display filter buttons after meta informations -->
    @if (list.id === 'general' && formCategories.length > 1) {
      <div class="form-categories">
        @for (category of formCategories; track category) {
          <ion-button [fill]="selectedCategory === category ? 'solid' : 'outline'"
            class="proto-button form-category-button"
            (click)="selectedCategory = category">
            {{ ('FORM.CATEGORY.' + category.toUpperCase()) | translate }}
          </ion-button>
        }
      </div>
    }

    @if (selectedCategory === 'all' || !list.category || list.category === selectedCategory) {
      @if (list.type === 'dynamic') {
        @for (item of list.items; track item.id) {
          @let control = asFormArray(item.id);
          <proto-dynamic-form-field
            [field]="item"
            [formArray]="control"
            [values]="dynamicFields[item.id]"
            (valueUpdated)="onValueUpdated($event, item.id)"></proto-dynamic-form-field>
        }
      } @else {
        @if (list.title) {
          <div class="proto-list-note proto-list-note--inset is-top">{{ list.title | translate }}
          </div>
        }
        <ion-list class="proto-input-list" inset>
          @for (item of list.items; let i = $index; track item.id) {
            <!-- dynamic fields are already part of dynamic fieldset -->
            @if (item.type !== 'dynamic') {
              @let control = asFormControl(item.id);
              <proto-form-field
                [ngClass]="{ 'has-badge-buttons': item.type === 'selectModal' && selectedItems[item.id]?.length }"
                [control]="control"
                [field]="item"
                (openModal)="openModal($event)"
                (valueUpdated)="onValueUpdated($event, item.id)"></proto-form-field>

              @if (showFilterForm) {
                @if (item.id === 'includeSelfHelpAddresses') {
                  @if (includeByType.selfHelpAddress) {
                    <div class="smart-filter-block">
                      <div
                        class="proto-list-note">{{ 'FORM.INPUT.SELF_HELP_ADDRESS_FILTER.LABEL' | translate }}
                      </div>
                      <page-filter
                        [isInline]="true"
                        [appliedWhereFilter]="selfHelpAddressFilterFormData"
                        [formType]="'selfHelpAddress'"
                        [listSubId]="'all'"
                        [topicLabelById]="organizationTopicLabelById"
                        (filterChanged)="onSelfHelpAddressFilterChanged($event)"></page-filter>
                    </div>
                  }
                }

                @if (item.id === 'includeOtherAddresses') {
                  @if (includeByType.otherAddress) {
                    <div class="smart-filter-block">
                      <div
                        class="proto-list-note">{{ 'FORM.INPUT.OTHER_ADDRESS_FILTER.LABEL' | translate }}
                      </div>
                      <page-filter
                        [isInline]="true"
                        [appliedWhereFilter]="otherAddressFilterFormData"
                        [formType]="'otherAddress'"
                        [listSubId]="'all'"
                        [topicLabelById]="organizationTopicLabelById"
                        (filterChanged)="onOtherAddressFilterChanged($event)"></page-filter>
                    </div>
                  }
                }

                @if (item.id === 'includePersons') {
                  @if (includeByType.person) {
                    <div class="smart-filter-block">
                      <div
                        class="proto-list-note">{{ 'FORM.INPUT.PERSON_FILTER.LABEL' | translate }}
                      </div>
                      <page-filter
                        [isInline]="true"
                        [appliedWhereFilter]="personFilterFormData"
                        [formType]="'person'"
                        (filterChanged)="onPersonFilterChanged($event)"></page-filter>
                    </div>
                  }
                }
                @if (item.id === 'includeContactPersons' && includeByType.contactPerson) {
                  <div class="smart-filter-block">
                    <div class="proto-list-note">{{ 'FORM.INPUT.CONTACT_PERSON_FILTER.LABEL' | translate }}</div>
                    <page-filter [isInline]="true" [appliedWhereFilter]="contactPersonFilterFormData"
                      [formType]="'person'" [formId]="'filterContactPerson'" (filterChanged)="onContactPersonFilterChanged($event)"></page-filter>
                  </div>
                }
                @if (item.id === 'includeTopics' && includeByType.topic) {
                  <div class="smart-filter-block">
                    <div class="proto-list-note">{{ 'FORM.INPUT.TOPIC_FILTER.LABEL' | translate }}</div>
                    <page-filter
                      [isInline]="true"
                      [appliedWhereFilter]="topicFilterFormData"
                      [formType]="'topic'"
                      (filterChanged)="onTopicFilterChanged($event)"></page-filter>
                  </div>
                }
              }

              @if (item.type === 'selectModal' && badgePreviewItems[item.id]?.length) {
                @if (hasBadgePreviewOverflow[item.id]) {
                  <div class="form-list-note">
                  {{ 'FORM.INPUT.CLUSTER_SELECTION_PREVIEW_HINT.LABEL' | translate }}
                  </div>
                }

                <div class="select-modal-badge-buttons">
                  @for (selectedItem of badgePreviewItems[item.id]; track selectedItem.id) {
                    <ion-button class="select-modal-badge-button" mode="ios" size="small"
                      color="medium-secondary"
                      (click)="removeItemFromSelectModal(item.id, selectedItem.id)">
                      {{ selectedItem.displayName }}
                      <ion-icon name="close-outline" slot="end"></ion-icon>
                    </ion-button>
                  }
                </div>
              }
            }
          }
        </ion-list>
      }
    }

  }

  <div class="footer-content">
    <ion-button class="proto-button" fill="outline" color="dark"
      [skipDialog]="!formIsValid()"
      (confirm)="processCompleted.emit('canceled')">
      {{ 'BUTTON.CANCEL' | translate }}
    </ion-button>

    <ion-button class="proto-button submit-button"
      [disabled]="!formIsValid() || isLoading"
      (click)="submit()">
      @if (isEditMode) {
        {{ 'BUTTON.SAVE' | translate }}
      } @else {
        {{ 'BUTTON.CREATE' | translate }}
      }
    </ion-button>
  </div>

</form>
